import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {AuthService} from '../shared/services/auth.service';
import {LoaderService} from '../components/loading-bar/loader.service';
import {NotificationService} from '../shared/services/notification.service';

@Injectable({providedIn: 'root'}) export class HttpConfigInterceptor implements HttpInterceptor {
  static readonly SERVER_ERROR = {
    TOKEN: 'Token has expired.',
    USER: 'Invalid user.',
    INVALID_TOKEN: 'Invalid token',
    NO_TOKEN: 'No token found.'
  };



  private requests: HttpRequest<any>[] = []; // Store pending requests

  constructor(private auth: AuthService, private loaderService: LoaderService, private notificationService: NotificationService) {

  }

  private removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1); // remove request from array
    }

    this.scheduleLoadingUpdate(this.requests.length > 0);
  }

  // Defer the BehaviorSubject emission to a microtask so subscribers
  // (notably the async pipe in LoadingBarComponent) update OUTSIDE any
  // currently running change-detection cycle. Emitting synchronously from
  // intercept()/removeRequest() can flip the loader value mid-CD and trigger
  // NG0100 ExpressionChangedAfterItHasBeenCheckedError.
  private scheduleLoadingUpdate(value: boolean) {
    queueMicrotask(() => this.loaderService.isLoading.next(value));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipLoader = request.headers.has('X-Skip-Loader');

    request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

    if (skipLoader) {
      request = request.clone({ headers: request.headers.delete('X-Skip-Loader') });
    } else {
      this.requests.push(request);
      this.scheduleLoadingUpdate(true);
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (!skipLoader) {
            this.removeRequest(request);
          }
          if (event.body && event.body.error) {
            if (event.body.error !== HttpConfigInterceptor.SERVER_ERROR.INVALID_TOKEN && event.body.error !== HttpConfigInterceptor.SERVER_ERROR.NO_TOKEN) {
              this.notificationService.open(event.body.error);
            }
            if (
              (event.body.error === HttpConfigInterceptor.SERVER_ERROR.TOKEN) ||
              (event.body.error === HttpConfigInterceptor.SERVER_ERROR.USER)
            ) {
              this.auth.clearStoredUserData();
            }
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (!skipLoader) {
          this.removeRequest(request);
        }
        this.auth.notificationService.open(`Error ${error.status}. Something went wrong`);
        return throwError(error);
      }));
  }
}
